export default "__VITE_ASSET__DAZlXLt8__"